import React, { useEffect, useRef, useState } from "react"
import * as THREE from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { useParts } from "../provider/PartsContext"

const ScrewModel = () => {
  const { modelComponents } = useParts()
  console.log("ScrewModel", modelComponents)
  const canvasRef = useRef(null)
  const [cameraFor, setCameraFor] = useState(10)
  const [cameraAspect, setCameraAspect] = useState(
    window.innerWidth / window.innerHeight
  )
  const [cameraNear, setCameraNear] = useState(0.1)
  const [cameraFar, setCameraFar] = useState(100)
  const getFor = (objWidth, distance) => {
    return 2 * Math.atan(objWidth / (2 * distance))
  }
  useEffect(() => {
    if (!canvasRef.current) return

    // WebGLRenderer
    const renderer = new THREE.WebGLRenderer({
      canvas: canvasRef.current,
      antialias: true,
    })
    renderer.setSize(window.innerWidth, window.innerHeight)

    // Scene
    const scene = new THREE.Scene()
    scene.background = new THREE.Color(0xffffff)

    // PerspectiveCamera
    const camera = new THREE.PerspectiveCamera(
      cameraFor,
      cameraAspect,
      cameraNear,
      cameraFar
    )
    camera.position.set(0, 0, 100)
    camera.updateProjectionMatrix()
    // camera.target.set(0, 0, 0)

    // AmbientLight
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.3)
    scene.add(ambientLight)

    // HemisphereLight
    const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x000000, 0.5)
    scene.add(hemisphereLight)

    const controls = new OrbitControls(camera, renderer.domElement)

    const loader = new GLTFLoader()

    let loadedModels = []

    console.log("modelComponents", modelComponents)
    Object.entries(modelComponents).forEach(([key, model]) => {
      // Load
      loader.load(model.parts.path, (gltf) => {
        const box = new THREE.Box3().setFromObject(gltf.scene)
        const size = box.getSize(new THREE.Vector3())
        loadedModels.push({
          gltfScene: gltf.scene,
          modelWidth: size.x,
          index: model.index,
          reverse: model.parts.reverse,
        })

        // 着色
        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            const material = new THREE.MeshStandardMaterial({
              color: model.color,
              transparent: false,
              opacity: 1,
            })
            child.material = material
          }
        })

        // すべてのモデルがロードされたら、再配置を行う
        if (loadedModels.length === Object.entries(modelComponents).length) {
          // 全パーツの全長の和を取得
          const totalWidthX = loadedModels.reduce((acc, loadedModel) => {
            return acc + loadedModel.modelWidth
          }, 0)
          controls.zoomSpeed = 0.4
          controls.minDistance = totalWidthX * 0.6
          controls.maxDistance = 4
          controls.target.set(0, 0, 0)

          // loadedModelsをindexに基づいてソートします
          loadedModels.sort((a, b) => a.index - b.index)

          // パーツの配置
          let accumulatedX = 0
          loadedModels.forEach((loadedModel, index) => {
            console.log("loadedModel : ", loadedModel)
            console.log("loadedModel.reverse : ", loadedModel.reverse)
            if (loadedModel.reverse) {
              loadedModel.gltfScene.rotation.y = Math.PI
            }
            const size = new THREE.Vector3(loadedModel.modelWidth, 0, 0)
            const center = new THREE.Box3()
              .setFromObject(loadedModel.gltfScene)
              .getCenter(new THREE.Vector3())

            if (index === 0) {
              loadedModel.gltfScene.position.x = 0 - totalWidthX / 2
            } else {
              loadedModel.gltfScene.position.x =
                accumulatedX + size.x / 2 - center.x - totalWidthX / 2
            }
            accumulatedX += size.x

            scene.add(loadedModel.gltfScene)
          })
          renderer.render(scene, camera)
        }
      })
    })

    const animate = () => {
      requestAnimationFrame(animate)
      controls.update()
      renderer.render(scene, camera)
    }

    animate()

    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()
      renderer.setSize(window.innerWidth, window.innerHeight)
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [modelComponents])

  return <canvas ref={canvasRef} />
}

export default ScrewModel
